import { useState, useEffect } from 'react'
import Map from 'components/Map/Map'
import FenetresAide from 'enums/FenetresAide'
import SideAndMain from 'layouts/SideAndMainLayout/SideAndMainLayout'
import { makeSelectSelectedParcelleMoreInformationIndex } from 'redux/features/parcelle/selectors'
import { Status as StatusParcelle } from 'redux/features/parcelle/slice'
import { useAppSelector } from 'redux/hooks'
import useBienAVendre from 'hooks/useBienAVendre'
import useSearchCircle from 'hooks/useSearchCircle'
import useDocumentTitle from 'hooks/useDocumentTitle'
import useUtilisateur from 'hooks/useUtilisateur'
import ResultsParcelle from 'components/Layers/ResultsParcelle/ResultsParcelle'
import SearchCircle from 'components/SearchCircle/SearchCircle'
import Detail from 'components/Parcelle/Details/Detail'
import ToastAlert from 'components/ToastAlert'
import QuizzAccesCiblerBienAVendre from 'components/Modal/QuizzAccesCiblerBienAVendre'
import PremierAccesCiblerBienAVendre from 'components/Modal/PremierAccesCiblerBienAVendre/PremierAccesCiblerBienAVendre'
import BiensAVendreNonAutorise from 'pages/BiensAVendreNonAutorise/BienAVendreNonAutorise'
import FormulaireDeRecherche from 'pages/BiensAVendre/components/FormulaireDeRecherche/FormulaireDeRecherche'
import ResultatsDeRecherche from 'pages/BiensAVendre/components/ResultatsdeRecherche/ResultatsDeRecherche'

const activationQuizz = process?.env?.REACT_APP_QUIZZ_ACTIVE === 'true'

const BiensAVendre = (): JSX.Element => {
  useDocumentTitle('Cibler bien')

  const { statusParcelle, errorParcelle, displayMode } = useBienAVendre()
  const { searchCircle } = useSearchCircle()

  const selectedParcelleMoreInformationIndex = useAppSelector(
    makeSelectSelectedParcelleMoreInformationIndex
  )

  const { utilisateur, checkUtilisateurAutorise } = useUtilisateur()
  const [showQuizz, setShowQuizz] = useState(false)

  useEffect(() => {
    if (
      utilisateur !== null &&
      !utilisateur.fenetreAide(FenetresAide.PremierAccesCiblerBienAVendre)
    )
      setShowQuizz(true)
  }, [utilisateur])

  if (!checkUtilisateurAutorise()) {
    return <BiensAVendreNonAutorise />
  }

  return (
    <SideAndMain
      aside={
        <>
          <ToastAlert
            show={statusParcelle === StatusParcelle.Failed}
            variant="danger"
          >
            {errorParcelle}
          </ToastAlert>

          <FormulaireDeRecherche displayMode={displayMode} />
          <ResultatsDeRecherche displayMode={displayMode} />
        </>
      }
      main={
        <>
          {activationQuizz ? (
            <QuizzAccesCiblerBienAVendre
              show={showQuizz}
              onHide={() => setShowQuizz(false)}
            />
          ) : (
            <PremierAccesCiblerBienAVendre
              show={showQuizz}
              onHide={() => setShowQuizz(false)}
            />
          )}
          <Map>
            <>
              {selectedParcelleMoreInformationIndex !== null && <Detail />}
              <ResultsParcelle />
              {searchCircle && displayMode.type === 'normal' && (
                <SearchCircle />
              )}
            </>
          </Map>
        </>
      }
    />
  )
}

export default BiensAVendre
